var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aTitle"},[_c('div',{staticClass:"title"},[_vm._v("武昌区重点人群健康管理")])])}]

export { render, staticRenderFns }